import Vue from 'vue';

// * PROGRESSBAR MIXIN
import progressBar_mixin from '@/modules/progressBar/progressBar_mixin.js';
Vue.use(progressBar_mixin);

// * PROGRESSBAR COMPONENT
import progressBar_component from '@/modules/progressBar/progressBar_component.vue';
Vue.component('progressbar', progressBar_component);
